import { useEffect } from "react";

/**
 * Pin a feed card's hover-lift look while a portaled overlay anchored inside
 */
export default function useCardHoverHold(anchorEl) {
  useEffect(() => {
    const card = anchorEl?.closest?.("[data-feed-card]");
    if (!card) return undefined;
    card.classList.add("card-hover-hold");
    return () => card.classList.remove("card-hover-hold");
  }, [anchorEl]);
}
